import React from "react";

const Alert = props => {
  return (
    <div className={`alert alert-${props.className} fade show`} role="alert">
      {props.message}
    </div>
  );
};

export default Alert;
